import { generateMnemonic, validateMnemonic } from "@scure/bip39";
import { wordlist } from "@scure/bip39/wordlists/english.js";

export type SecretPhrase = readonly string[];

export function secretPhraseToMnemonic(phrase: SecretPhrase): string {
  return phrase.join(" ");
}

export function isValidSecretPhrase(phrase: SecretPhrase): boolean {
  return phrase.length === 12 && validateMnemonic(secretPhraseToMnemonic(phrase), wordlist);
}

/**
 * 12-word BIP-39 English mnemonic from 128 bits of CSPRNG entropy.
 * Do not persist — it must exist only in memory for this page.
 */
export function generateSecretPhrase(): SecretPhrase {
  return generateMnemonic(wordlist, 128).split(" ");
}
